<template >
  <v-container>
    <v-row
      ><v-spacer></v-spacer>
      <v-btn color="red" outlined @click="logOut" :loading="loading">
        <v-icon left>mdi-logout</v-icon>Log Out
      </v-btn></v-row
    >

    <v-snackbar
      v-model="successMessage"
      :timeout="3000"
      outlined
      color="#2196cc"
    >
      <v-icon color="#2196cc">mdi-check-circle</v-icon>
      <span class="mx-2">Déconnexion réussie ! À bientôt !</span>
    </v-snackbar>
  </v-container>
</template>

<script>
import { auth } from "@/services/firebaseServices.js";

export default {
  data() {
    return {
      successMessage: false,
      loading: false
    };
  },
  methods: {
    logOut() {
      this.loading = true;
      auth.signOut();
      setTimeout(() => {
        this.successMessage = true;
      }, 1000);
      setTimeout(() => {
        this.loading = false;
        this.$store.dispatch("signOut");
      }, 2500);
    }
  }
};
</script>

<style>
</style>